import React from 'react';
import CalendarFareInMonth from './CalendarFareInMonth';

function Section03() {
  return (
    <CalendarFareInMonth
      type="depart"
    />
  );
}

export default React.memo(Section03);
